import { create } from "zustand";
import { API } from "../api";
import { IStep } from "../types";

interface IState {
  steps: IStep[];
  loaded_article: string | null;
  getSteps: (article_id: any) => void
}

export const useStore = create<IState>((set) => ({
  steps: [],
  loaded_article: null,
  getSteps: async (article_id) => {
    const response = await API.getSteps(article_id);
    set({ steps: response, loaded_article: article_id });
  },
}));
